import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { useAuth } from "../../context/Auth";

const TopDrugBreakdownModal = ({ isOpen, onClose, drug }) => {
  const { requestWithAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [breakdown, setBreakdown] = useState([]);

  useEffect(() => {
    if (isOpen && drug?.id) {
      fetchBreakdown();
    }
  }, [isOpen, drug]);

  const fetchBreakdown = async () => {
    setLoading(true);
    try {
      const response = await requestWithAuth(`/inventory/top-moving-items/${drug.id}/`, "GET");
      setBreakdown(Array.isArray(response) ? response : (response?.results || []));
    } catch (error) {
      console.error("Failed to load drug breakdown:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg overflow-hidden flex flex-col max-h-[80vh]">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Sales Breakdown</h2>
            <p className="text-sm text-gray-500 mt-1">{drug?.name}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1 custom-scrollbar">
          {loading ? (
            <div className="flex items-center justify-center py-10">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            </div>
          ) : breakdown.length > 0 ? (
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="py-3 px-4 text-sm font-semibold text-gray-600">Branch Name</th>
                  <th className="py-3 px-4 text-sm font-semibold text-gray-600 text-right">Quantity Sold</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {breakdown.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="py-3 px-4 text-sm font-medium text-gray-900">{item.branch_name}</td>
                    <td className="py-3 px-4 text-sm text-gray-700 text-right font-semibold">{item.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-center text-sm text-gray-500 py-10">No breakdown data available for this drug.</p>
          )}
        </div>

        <div className="flex items-center justify-end p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg text-sm font-medium transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopDrugBreakdownModal;
